export default __webpack_public_path__ + "static/28-6eb99c7f4c9f0148a4f768246bc20db1.jpg";